import styled from "@emotion/styled"
import { css } from "@emotion/react"
import Link from "components/Link"
import { PropTypes } from "prop-types"

const HeroBreadcrumbsLinkEl = ({ to, ...props }) => {
  if (to) {
    return (
      <Link isActive to={to} {...props} />
    )
  }

  return <li {...props} />
}

const dynamicStyles = ({ theme, to, colorVariant = 'Light' }) => css`
    color: ${colorVariant === "Dark"
    ? (!to && theme.palette.common.white) || theme.palette.gray[600]
    : (!to && theme.palette.gray[900]) || theme.palette.gray[600]};
    ${to && `
    padding-right: 27px;
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      right: 4.5px;
      border: solid #BBBBBB;
      border-width: 0 2px 2px 0;
      display: block;
      width: calc(12px * 0.7);
      height: calc(12px * 0.7);
      transform: translateY(-50%) rotate(135deg);
      transition: 0.3s;
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: -7px;
      transform: translate(-50%, -50%);
      width: 14px;
      height: 2px;
      background-color: #BBBBBB;
      transition: 0.3s;
    }
    `}
`

const HeroBreadcrumbsLink = styled(HeroBreadcrumbsLinkEl)`
  display: flex;
  align-items: center;
  text-decoration: none;
  font-weight: 600;
  padding: 5px 13px;
  position: relative;
  ${dynamicStyles}
`

export default HeroBreadcrumbsLink

HeroBreadcrumbsLinkEl.propTypes = {
  to: PropTypes.string,
}

HeroBreadcrumbsLinkEl.defaultProps = {
  to: "",
}
